export default "__VITE_ASSET__DkI45KVN__"